export const urls = {
  GET_RADNI_NALOG_ZA_MASINU: 'DokRNServisni/vrati_dok_rn_servisni_za_id_masine',
};
